import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-item prev" }
const _hoisted_2 = { class: "item-content" }
const _hoisted_3 = { class: "btn-group btn-group-vertical radio-group" }
const _hoisted_4 = { class: "radio-button btn" }
const _hoisted_5 = { class: "radio-button__label radio-text" }

import { useWizardStepsStore } from "../store/wizardStepsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviousStep',
  props: {
    step: {},
    index: {}
  },
  setup(__props: any) {

const props = __props;

const store = useWizardStepsStore();
const chosenValue = props.step.subItems.find((subItem) => subItem.id === props.step.chosenValue);

const goToPreviousStep = () => {
  // remove all steps after the clicked one and set it as active
  store.currentStep = props.step;

  const index = store.previousSteps.findIndex((step) => step.id === props.step.id);
  if (index !== -1) {
    store.previousSteps = store.previousSteps.slice(0, index);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "item-badge",
      onClick: goToPreviousStep
    }, _toDisplayString(__props.index + 1), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(__props.step.caption), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("input", {
            type: "radio",
            class: "radio-button__input active",
            checked: ""
          }, null, -1 /* CACHED */)),
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(chosenValue)?.caption), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}
}

})